export function isErrorEmailNotUnique(error) {
    return (error &&
        error.data &&
        Array.isArray(error.data.errors) &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error.data.errors.find((err) => {
            return err.column && err.column === 'email' && err.error && err.error === 'not-unique';
        }));
}
